export enum AuthPolicyEnum {
  UnregisteredPatientWithout2FA = 'UnregisteredPatientWithout2FA',
  UnregisteredPatientWith2FA = 'UnregisteredPatientWith2FA',
  RegisteredPatientWithout2FA = 'RegisteredPatientWithout2FA',
  FullTrustPatient = 'FullTrustPatient',
  InForgottonUsernameWorkflow = 'InForgottonUsernameWorkflow',
  InForgottonPasswordWorkflow = 'InForgottonPasswordWorkflow',
  FullTrustOrMagicLinkTrustPatient = 'FullTrustOrMagicLinkTrustPatient',
}